import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProdutoDocumentoService } from '../services/produto-documento.service';

@Injectable({
  providedIn: 'root',
})
export class ProdutoDocumentoResolver implements Resolve<boolean> {
  constructor(private service: ProdutoDocumentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
